/* klaasje-mail-menu
   Sluit het mailmenu bij een klik ernaast, bij Escape en na een keuze, en
   doet het kopiëren van het adres. Openklappen doet <details> zelf. */
(function () {
  if (window.klaasjeMailMenu) return;
  window.klaasjeMailMenu = true;

  function sluitAlles(behalve) {
    document.querySelectorAll('.klaasje-mail-menu[open]').forEach(function (menu) {
      if (menu !== behalve) menu.open = false;
    });
  }

  function kopieer(tekst) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(tekst);
    return new Promise(function (resolve, reject) {
      var veld = document.createElement('textarea');
      veld.value = tekst;
      veld.setAttribute('readonly', '');
      veld.style.position = 'fixed';
      veld.style.opacity = '0';
      document.body.appendChild(veld);
      veld.select();
      var gelukt = document.execCommand('copy');
      veld.remove();
      if (gelukt) resolve();
      else reject(new Error('kopiëren lukte niet'));
    });
  }

  document.addEventListener('click', function (e) {
    var menu = e.target.closest('.klaasje-mail-menu');
    sluitAlles(menu);
    if (!menu) return;

    var knop = e.target.closest('[data-klaasje-copy]');
    if (knop) {
      var oud = knop.textContent;
      kopieer(knop.dataset.klaasjeCopy).then(function () {
        knop.textContent = knop.dataset.klaasjeCopied;
        setTimeout(function () {
          knop.textContent = oud;
          menu.open = false;
        }, 1200);
      }, function () {
        /* Kopiëren mag niet: laat dan het adres zien, dan kan je het zelf. */
        knop.textContent = knop.dataset.klaasjeCopy;
      });
      return;
    }

    if (e.target.closest('a.klaasje-mail-menu__item')) {
      setTimeout(function () { menu.open = false; }, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.klaasje-mail-menu[open]');
    if (!open) return;
    open.open = false;
    open.querySelector('summary').focus();
  });
})();
